import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;

  .back-to-listing-button {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.primary};
  }

  .back-to-listing-divider {
    font-weight: 400;
    margin: 0 8px;
    color: ${({ theme }) => theme.colors.primary};
  }

  .back-to-listing-title {
    margin: 0 8px;
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.2rem;
    font-weight: 600;
  }
`;
